import React, { useState } from "react";
import "../App.css";
import { Image } from "react-bootstrap";
import logo from "../img/eaim_logo_original.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTheme } from "./ThemeContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const { isDark } = useTheme();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {
        userName,
        password,
      });

      if (response.data.success) {
        const user = response.data.user;
        const token = response.data.token;

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("authToken", token);
        if (response.data.user.role === "Staff") {
          navigate("/my-appraisal");
        } else if (response.data.user.description === "HR") {
          navigate("/hr-dashboard");
        } else {
          navigate("/sup-dashboard");
        }
      } else {
        setErrorMsg(response.data.message || "Login failed.");
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg("Server error. Please try again later.");
      }
    }
  };

  return (
    <>
      <div className="text-center">
        <Image src={logo} width="300px" alt="Logo" />
      </div>
      <div className="login-container">
        <h2
          className="mb-4 fw-bold text-center"
          style={{ color: isDark ? "#fff" : "#000" }}
        >
          Sign in
        </h2>

        {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}

        <form className="login-form" onSubmit={handleLogin}>
          <div className="mb-3">
            <input
              type="text"
              className={`form-control ${
                isDark ? "bg-dark text-white border-secondary" : ""
              }`}
              placeholder="Username"
              required
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <input
              type="password"
              className={`form-control ${
                isDark ? "bg-dark text-white border-secondary" : ""
              }`}
              placeholder="Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <small className={isDark ? "text-secondary" : "text-muted"}>
            * Please use your SEMS account to Sign in.
          </small>

          <button className="sign-in-button mt-4" type="submit">
            Sign in
          </button>
        </form>
      </div>
    </>
  );
};

export default LoginPage;
